import { render, staticRenderFns } from "./Gesundheitskosten.vue?vue&type=template&id=841a4a9c&"
import script from "./Gesundheitskosten.vue?vue&type=script&lang=js&"
export * from "./Gesundheitskosten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports